import { animate, spring } from "motion";
const { disableBodyScroll, enableBodyScroll } = require("body-scroll-lock");

export default class NavOverlay {
  constructor(navbar) {
    this.navbar = navbar;
    this.toggle = $(this.navbar).find(".page-navbar__overlay-toggle")[0];
    // this.searchWrapper = $(".search-wrapper")[0];
    this.mainContent = $(".main-content")[0];
    this.pageFooter = $(".page-footer")[0];

    if (this.toggle) {
      this._init();
    }
  }

  _init() {
    this.$subNavs = $(this.navbar).find(
      ".page-navbar__overlay li.menu-item-has-children.menu-item"
    );
    this.$subNavsLinks = $(this.navbar).find(
      ".page-navbar__overlay li.menu-item-has-children.menu-item > a"
    );
    this.overlay = $(this.navbar).find(".page-navbar__overlay")[0];
    this.menu = $(this.navbar).find(".page-navbar__overlay-menu")[0];

    this.toggle.addEventListener("click", this._handelToggleClick.bind(this));
    this.$subNavsLinks.on("click", this._handelNavItemsClick.bind(this));

    $(window).on(
      "luther:overlay-instead-of-desktop",
      this._handleDesktopnavToggle.bind(this)
    );
  }

  _handelNavItemsClick(evt) {
    evt.preventDefault(evt);
    const $parentLi = $(evt.currentTarget).closest("li");
    this._toggleSubMenu($parentLi);
  }

  _handelToggleClick() {
    var isOverlayOpen = this.isOverlayOpen || false;
    if (!isOverlayOpen) {
      this._openOverlay();
    } else {
      this._closeOverlay();
    }
  }

  _toggleSubMenu($parentLi) {
    if (!$parentLi.hasClass("is-open")) {
      this._openSubmenu($parentLi);
    } else {
      this._hideSubmenu($parentLi);
    }
  }

  _openSubmenu($parentLi) {
    const sub = $parentLi.find(".sub-menu").first()[0];
    if (!sub || !sub.scrollHeight) return;
    $parentLi.addClass("is-open");
    animate(
      sub,
      {
        height: sub.scrollHeight + "px",
      },
      { duration: 0.1, easing: spring({ stiffness: 300, damping: 100 }) }
    );
  }

  _hideSubmenu($parentLi) {
    const sub = $parentLi.find(".sub-menu").first()[0];
    $parentLi.removeClass("is-open");
    animate(
      sub,
      {
        height: "0",
      },
      { duration: 0.5 }
    );
  }
  _handleDesktopnavToggle(showDesktopNav) {
    if (showDesktopNav && this.isOverlayOpen) {
      this._closeOverlay();
    }
  }

  _openOverlay() {
    this.isOverlayOpen = true;
    this.overlay.removeAttribute("inert");
    this.overlay.setAttribute("aria-hidden", "false");
    this.toggle.setAttribute("aria-expanded", "true");
    // this.searchWrapper.setAttribute("inert", "");
    this.mainContent.setAttribute("inert", "");
    this.pageFooter.setAttribute("inert", "");
    this.navbar.classList.add("overlay-is-open");
    disableBodyScroll(this.overlay);
  }

  _closeOverlay() {
    this.isOverlayOpen = false;
    this.overlay.setAttribute("inert", "");
    this.overlay.setAttribute("aria-hidden", "true");
    this.toggle.setAttribute("aria-expanded", "false");
    // this.searchWrapper.removeAttribute("inert");
    this.mainContent.removeAttribute("inert");
    this.pageFooter.removeAttribute("inert");
    this.navbar.classList.remove("overlay-is-open");
    enableBodyScroll(this.overlay);
  }
}
